'use client';

import Image from 'next/image';
import type { IMegaMenuNavigationItemColumnGrid } from '../../Header/interfaces';
import { Icon, Typography } from '@workspace/ui/common';
import { MegaMenuContainer } from '../MegaMenuContainer';
import { sanityImageSrc } from '@/sanity/lib/image';
import { normalizeAltText } from '@workspace/constants';

interface GridMegaMenuProps {
  items?: IMegaMenuNavigationItemColumnGrid[];
  isClosing?: boolean;
}

export default function GridMegaMenu({ items = [], isClosing = false }: GridMegaMenuProps) {
  const handleClick = (raw?: string) => {
    if (typeof window !== 'undefined' && raw) window.location.assign(raw);
  };

  return (
    <MegaMenuContainer className="flex justify-center py-4xl py-xl min-h-163.5" isClosing={isClosing}>
      <div className="w-full max-w-300 relative">
        {/* Notes: Remove the fixed width and let the grid decide the width of the cards */}
        <div className="grid grid-cols-4 gap-x-lg gap-y-12">
          {items.map((item) => {
            return (
              <div key={item._key} className="cursor-pointer group" onClick={() => handleClick(item.link?.url)}>
                <div className="relative mb-2 overflow-hidden w-full h-43.25">
                  {item.thumbnail && (
                    <Image
                      src={sanityImageSrc(item.thumbnail, {
                        width: 564,
                        height: 346,
                      })}
                      alt={normalizeAltText(item.thumbnail.alt) || item.label}
                      fill
                      className="object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  )}
                </div>

                <div className="space-y-1 font-openSans">
                  <div className="flex items-center justify-between">
                    <Typography
                      variant="bodyMd"
                      className="font-semibold text-secondary-400 transition-colors text-base! font-openSans"
                    >
                      {item.label}
                    </Typography>

                    <div className="icon-container w-6 h-6">
                      <Icon
                        name="arrowRightIcon"
                        size={24}
                        className="transition-transform duration-500 group-hover:translate-x-1 text-primary"
                      />
                    </div>
                  </div>
                  <Typography className="text-sm text-secondary-400 line-clamp-3" variant="bodySm">
                    {item.description}
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </MegaMenuContainer>
  );
}
